import React from "react";
import { SkeletonBox } from "./SkeletonBox";
import { 
  SkeletonSize, 
  SkeletonWidth, 
  SKELETON_TEXT_SIZES, 
  SKELETON_TEXT_WIDTHS 
} from "@/common/skeleton.common";

interface SkeletonTextProps {
  size?: SkeletonSize;
  width?: SkeletonWidth;
  className?: string;
}

const getWidthClass = (width: SkeletonWidth): string => {
  return typeof width === "string" && width in SKELETON_TEXT_WIDTHS
    ? SKELETON_TEXT_WIDTHS[width as keyof typeof SKELETON_TEXT_WIDTHS]
    : width;
};

export const SkeletonText = React.memo<SkeletonTextProps>(({ 
  size = "sm", 
  width = "lg",
  className 
}) => {
  const heightClass = SKELETON_TEXT_SIZES[size];
  const widthClass = getWidthClass(width);

  return (
    <SkeletonBox
      height={heightClass}
      width={widthClass}
      className={className}
    />
  );
});

SkeletonText.displayName = "SkeletonText"; 